<template>
  <ZMainPage type="card" v-loading="loading">
    <div class="course-page">
      <div class="course-header">
        <div>
          <div class="title">{{ info.teach_name }}</div>
          <div class="flex info">
            <div class="item">{{ info.apply_type_name }}</div>
            <div class="item">{{ info.subject_name }}</div>
            <div class="item">{{ info.grade }}</div>
            <div class="item">
              <span class="txt">创建人</span>
              <span class="ml-3 val">{{ info.creator }}</span>
            </div>
            <div class="item">
              <span class="txt">创建时间</span>
              <span class="ml-3 val">{{ info.created_at }}</span>
            </div>
          </div>
        </div>
        <div class="view" @click="handleView">查看备注</div>
      </div>
      <div class="course-container">
        <div class="course-lectures">
          <div :class="['course-lectures-item', { active: courseIdx === idx }]" v-for="(i, idx) in list" :key="i.id" @click="handleSelectCourse(idx)">
            <div class="title">第{{ i.sort_num }}讲</div>
            <div class="content">{{ i.article_name }}</div>
          </div>
        </div>
        <div class="course-content">
          <div class="course-content-tabs">
            <div
            :class="['item', { active: typeIdx === idx }]"
            v-for="(item, idx) in types" :key="item.value"
            @click="handleChangeType(idx)"
            >{{ item.label }}</div>
          </div>
          <div class="course-content-list">
            <div class="course-content-empty" v-if="!flies.length"><Empty /></div>
            <div class="item" v-for="i in flies">
              <div class="icon">
                <img class="img" :src="`/upload/${i.file_extension}.png`" alt="">
              </div>
              <div class="title">{{ i.file_name }}</div>
              <el-button class="btn" plain type="primary" icon="el-icon-download" @click="handleDownload(i)">下载</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog :visible.sync="visible" buttonAlign="center" title="查看备注" submitText="关闭" :showCancelButton="false">
      {{ info.remark }}
    </Dialog>
  </ZMainPage>
</template>

<script>
import Dialog from '@/components/common/Dialog'
import Empty from '@/components/common/ZuEmpty'
import http from '@/api'
import { handleDownFile } from '@/utils'
export default {
  _config:{'route':{'path':'detail','meta':{'title':'详情'}}},
  components: { Dialog, Empty },
  data() {
    return {
      id: '',
      loading: false,
      visible: false,
      types: [
      { value: 4, label: 'PPT课件' },
        { value: 2, label: '学案' },
        { value: 3, label: '作业案' },
        { value: 1, label: '教案' },
        { value: 6, label: '视频' },
        { value: 5, label: '课堂资源' }
      ],
      courseIdx: 0,
      typeIdx: 0,
      info: {},
      list: []
    }
  },
  computed: {
    flies() {
      const course = this.list[this.courseIdx] || {}
      const val = this.types[this.typeIdx].value
      const list = course.time_course_resource || []
      if (!list.length) return []
      const obj = list.find(i => i.resource_type === val)
      if (!obj) return []
      const flies = obj.resource_list || []
      return flies
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const id = this.$route.query.id
      if (!id) return
      this.loading = true
      http({ url: '/time-course/get', pre: 'zh' }, { id }).then(res => {
        const { teach_name, apply_type_name, subject_name, teach_grade = [], creator, created_at, remark, time_course_article = [] } = res
        this.info = { teach_name, apply_type_name, subject_name, grade: teach_grade.join('、'), creator, created_at, remark }
        this.list = time_course_article
      }).finally(() => this.loading = false)
    },
    handleView() {
      this.visible = true
    },
    handleSelectCourse(idx) {
      if (this.courseIdx === idx) return
      this.courseIdx = idx
      this.typeIdx = 0
    },
    handleChangeType(idx) {
      this.typeIdx = idx
    },
    handleDownload(i) {
      handleDownFile({ url: i.file_address, type: i.file_extension, name: i.file_name })
    }
  }
}
</script>

<style lang="scss" scoped>
.course {
  &-page {
    height: calc(100vh - 120rem);
    display: flex;
    flex-direction: column;
  }
  &-header {
    height: 160rem;
    margin-bottom: 24rem;
    padding: 40rem;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    border-radius: 6rem;
    .title {
      font-size: 32rem;
      font-weight: 500;
      color: #222;
      margin-bottom: 24rem;
    }
    .info {
      font-size: 18rem;
      color: #666;
      gap: 20rem;
    }
    .item {
      margin-right: 40rem;
      .txt {
        color: #888;
      }
      .val {
        color: #1D2088;
      }
    }
    .view {
      font-size: 18rem;
      color: #888;
      cursor: pointer;
    }
  }
  &-container {
    height: calc(100vh - 304rem);
    overflow: auto;
    display: flex;
  }
  &-lectures {
    width: 280rem;
    height: calc(100vh - 304rem);
    margin-right: 24rem;
    flex-shrink: 0;
    background-color: #EEF0F4;
    overflow: auto;
    border-radius: 4rem;
    &-item {
      position: relative;
      height: 156rem;
      padding: 24rem;
      cursor: pointer;
      user-select: none;
      &.active {
        background-color: #fff;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 3rem;
          height: 100%;
          background-color: #598BFF;
          border-radius: 4rem;
        }
      }
      .title {
        margin-bottom: 12rem;
        color: #3C3C3C;
        font-size: 20rem;
        font-weight: 500;
      }
      .content {
        color: #666;
        font-size: 15rem;
        line-height: 30rem;
      }
    }
  }
  &-content {
    min-width: 0;
    flex: 1;
    background-color: #fff;
    border-radius: 4rem;
    &-tabs {
      display: flex;
      border-bottom: #F4F4F4 solid 1rem;
      .item {
        position: relative;
        width: 124rem;
        height: 66rem;
        padding: 0 20rem;
        font-size: 18rem;
        color: #3C3C3C;
        user-select: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        &.active {
          color: #1C4EFD;
          &::before {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            border-style: solid;
            border-width: 6rem;
            border-color: transparent transparent #1C4EFD transparent;
            transform: translateX(-50%);
          }
          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1px;
            background-color: #1C4EFD;
          }
        }
      }
    }
    &-list {
      height: calc(100vh - 370rem - 1px);
      padding: 0 24rem;
      overflow: auto;
      .item {
        display: flex;
        align-items: center;
        padding: 36rem 16rem;
        border-bottom: 1rem solid #EFEFEF;
        .icon {
          width: 68rem;
          height: 68rem;
          margin-right: 24rem;
          flex-shrink: 0;
        }
        .img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .title {
          min-width: 0;
          flex: 1;
          color: #3D3D3D;
          font-size: 20rem;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .btn {
          margin-left: 24rem;
          flex-shrink: 0;
        }
      }
    }
    &-empty {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
